module.exports = __webpack_public_path__ + "static/media/corporate-services-img32.09342ec0.jpg";